import { i18n, Row, Cell, utils, Form, Icon, http } from '@common';
import { useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { CISInput, CISPasswordInput } from '../input/input';
import LodingButton from '../lodingButton/index';
import "./index.less";
import { emailOTPService, transferService, accountService } from '@api';
import { routerPaths } from '../../tool';
import { setCookie, getCookie } from '../../utils/utils';

const EmailOTP = (props) => {
    const params = utils.geturlparam(props?.location.search);
    let initTimer = 60;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isResendIn, setIsResendIn] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isResend, setIsResend] = useState(false);
    const [isPasswordValidate, setIsPasswordValidate] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [times, setTimes] = useState(0);
    const [isEmailOTP] = useState(false);
    const [goBack] = useState(true);
    const [timer, setTimer] = useState(initTimer);
    const [verifyTime, setVerifyTime] = useState(0);
    const [loginDisabled, setLogindisabled] = useState(true);
    const [isShowEmailOTPDes, setIsShowEmailOTPDes] = useState(false);
    const [btnIsDisable, setBtnIsDisable] = useState(false);
    const [cookieDisable, setCookieDisable] = useState(false);
    const [hasNoStudentId, setHasNoStudentId] = useState(true);
    const formRef = useRef();
    const emailRef = useRef();
    const { obj } = params;
    const from = obj.from || '';
    const checkCookie = getCookie('disablebtn');
    const emailLogin = JSON.parse(sessionStorage['transferData'] || null);
    const emailLogicalName = emailLogin?.detail?.EmailOTP?.logicalName;

    useEffect(() => {
        if (loginDisabled && btnIsDisable) setCookieDisable(true);
    }, [btnIsDisable, loginDisabled]);

    useEffect(() => {
        if (checkCookie) {
            setBtnIsDisable(true);
            setIsDisabled(true);
        } else {
            setBtnIsDisable(false);
            setLogindisabled(false);
        }
    }, [checkCookie]);

    const login = useCallback((e) => {
        const sendInput = document.querySelector('.send-otp')?.querySelector('#inputCommon');
        const loginInput = document.querySelector('.login-by-otp')?.querySelector('#inputCommon');
        let timer = null;
        if (timer) { clearTimeout(timer); }
        timer = setTimeout(() => {
            if (e.key === 'Enter' && sendInput && sendInput === document.activeElement) {
                let subInput = null;
                setEmail(inputItem => {
                    subInput = inputItem;
                    return inputItem;
                });
                handleSendCode(subInput);
            } else if (e.key === 'Enter' && loginInput && loginInput === document.activeElement) {
                let subObj = {};
                setEmail(inputItem => {
                    subObj.inputEmail = inputItem;
                    return inputItem;
                });
                setPassword(inputPassword => {
                    subObj.inputPassword = inputPassword;
                    subObj.inputFrom = obj?.from;
                    return inputPassword;
                });
                if (loginDisabled === false) {
                    handleLogin(subObj);
                }
            }
        }, 200);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleLogin, handleSendCode, loginDisabled, obj?.from, verifyTime]);

    useEffect(() => {
        document.addEventListener('keyup', login);

        return () => {
            document.removeEventListener("keyup", login);
        };

    }, [handleLogin, handleSendCode, login, loginDisabled, obj.from, verifyTime]);

    useEffect(() => {
        if (password === '') {
            setIsPasswordValidate(false);
        }
    }, [password]);

    const handleSendCode = useCallback((enterEmail = null) => {
        if (!emailRef.current.validate()) {
            return;
        }
        $$.loading(true);

        emailOTPService.sendCode({ target: email || enterEmail, forRetrieve: (from === 'retrieveEmailOTP' || from === 'enable') ? true : false }).then(_ => {
            sendOTP();
            $$.toast(i18n.get('CIS_Home_EmailOTP_Sendcode_Success_Message'));
            setIsShowEmailOTPDes(true);
        }).catch(err => {
            if (err?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.toast(i18n.get('CIS_Home_EmailOTP_Sendcode_Same_Message'), 'error');
            }
            if (err?.errorCode === http.ErrorCode.CodeError) {
                setHasNoStudentId(false);
            }
        }).finally(_ => {
            $$.loading(false);
        });
    }, [email, sendOTP]);

    const sendOTP = useCallback(() => {
        setLogindisabled(false);
        setTimes((prevCount) => {
            if (prevCount > 2) {
                setCookie('disablebtn', true, 60);
                setIsDisabled(true);
            }
            return prevCount + 1;
        });
        setVerifyTime(0);
        setIsResendIn(false);
        const auth_timer = setInterval(() => {
            setTimer((prevCount) => {
                if (prevCount > 0) {
                    return prevCount - 1;
                } else {
                    setIsResendIn(true);
                    setIsResend(true);
                    setTimer(60);
                }
                clearInterval(auth_timer);
            });
        }, 1000);
    }, []);

    const handleLogin = useCallback((subObj = {}) => {
        const { obj } = params;
        const { inputEmail, inputPassword, inputFrom } = subObj;
        if (!formRef.current.validate()) {
            return;
        }
        $$.loading(true);
        transferService.getRetrieveUrl(emailLogicalName, obj.state, 'emailOTP').then(res => {
            emailOTPService.validateLogin({ target: email || inputEmail, state: obj.state, code: password || inputPassword, from: from || inputFrom }).then(res => {
                if (from === 'retrieveSingPass' || from === 'retrieveEmailOTP') {
                    utils.redirectTo(res.detail);
                    setIsPasswordValidate(false);
                } else {
                    if (from === 'enable') {
                        window.wogaaCustom?.completeTransactionalService('cispoliteedu-4705');
                    } else if (!from) {
                        window.wogaaCustom?.completeTransactionalService('cispoliteedu-4704');
                    }

                    window.location.href = res.detail;
                    setIsPasswordValidate(false);
                }
            }).catch(err => {
                if (err.errorCode === http.ErrorCode.CodeError) {
                    setIsPasswordValidate(true);
                    if (verifyTime < 2) {
                        setVerifyTime(verifyTime + 1);
                    } else {
                        setLogindisabled(true);
                    }
                }
                if (err.errorCode === http.ErrorCode.CatchErrorCode) {
                    $$.toast(i18n.get('CIS_Home_EmailOTP_Sendcode_Same_Message'), 'error');
                }
            }).finally(_ => {
                $$.loading(false);
            });

        }).catch(e => {
            if (e?.errorCode !== http.ErrorStatus.Successed) {
                accountService.regoLogin(`${utils.getOriginUrl()}/student`).then((res) => {
                    $$.toast(i18n.get('CIS_Home_EmailOTP_ProxyStateExpired_Message'), 'warning');
                    setTimeout(() => {
                        utils.redirectTo(res?.detail);
                    }, 2000);
                });
            }
        }).finally(_ => {
            $$.loading(false);
        });
    }, [params, emailLogicalName, email, password, from, verifyTime]);

    const emailValidate = (value) => {
        if (!value || !$$.type.isEmail(value)) {
            return i18n.get("CIS_Home_EmailOTP_Email_Validate_Message");
        }
        return true;
    };

    const handleBackClick = (state) => {
        transferService.regetProxyState(state).then(() => {
            utils.redirectTo(routerPaths.home, isEmailOTP, goBack);
        });
    };

    const loginButtonText = useMemo(() => {
        if (cookieDisable) {
            return i18n.get('CIS_Home_EmailOTP_BlockSendOTP_Entry');
        }
        if (loginDisabled) {
            return i18n.get('CIS_Home_EmailOTP_Entercode_Error_Manytimes_Entry');
        }
        if (from === 'retrieveEmailOTP') {
            return i18n.get('CIS_Retrieve_Verify_Button_Entry');
        } else if (from === 'enable') {
            return i18n.get('CIS_Enable_LoginAndLogin_Button_Entry');
        }
        return i18n.get('CIS_Home_Singpass_EmailOTP_Login_Entry');
    }, [from, loginDisabled, cookieDisable]);

    return (
        <div className='emailFrom'>
            <div className='box'>
                <div className='backTextIcon'>
                    <Icon className='fia-arrow-left' id="icon-back" onClick={() => handleBackClick(obj?.state)}></Icon>
                    <div className='text'>{i18n.get("CIS_Home_Singpass_EmailOTP_Entry")}</div>
                </div>
                <Form ref={formRef}>
                    {isShowEmailOTPDes &&
                        <Row>
                            <Cell style={{ fontSize: '20px', color: '#27313C' }}>{i18n.get("CIS_Home_EmailOTP_Tiltle_description_Message")}</Cell>
                        </Row>}
                    <Row style={{ marginTop: '48px', marginBottom: '48px' }}
                        validation={{
                            type: "input",
                            valFunction: emailValidate,
                        }}
                        ref={emailRef}>
                        {isResendIn ?
                            <R.Button
                                classify="info"
                                icon="fia-arrow-right-subnav"
                                className="reverse"
                                text={isResend ? i18n.get('CIS_Home_Singpass_EmailOTP_ReSendOTP_Entry') : i18n.get('CIS_Home_Singpass_EmailOTP_SendOTP_Entry')}
                                attrs={{ 'style': 'border-radius: 8px; font-size: 18px ;height:39px; position: absolute;top: 0;right: 12px;' }}
                                onClick={handleSendCode}
                                disabled={isDisabled}
                            />
                            :
                            <LodingButton
                                text={i18n.get('CIS_Home_Singpass_EmailOTP_ResendIn_Entry', timer)}
                            />
                        }
                        <CISInput
                            classNames={'send-otp'}
                            iconClassName={'fia-email-envelope'}
                            placeholder={i18n.get('CIS_Home_Singpass_EmailOTP_Email_Placeholder_Message')}
                            hasButton
                            type={'text'}
                            isChangeRed={!hasNoStudentId}
                            onChange={value => { setEmail(value); setHasNoStudentId(true); }}
                            id="input-email"
                        />
                        <R.ValidationFaker of={"#input-email"} valid={hasNoStudentId} message={i18n.get("CIS_Verification_HasStudentId_EmialOTP")} />
                    </Row>
                    <Row style={{ marginBottom: '40px' }} validation='Input' required>
                        <CISInput
                            classNames={'login-by-otp'}
                            iconClassName={'fia-lock'}
                            placeholder={i18n.get('CIS_Home_Singpass_EmailOTP_Password_Placeholder_Message')}
                            type={'password'}
                            isChangeRed={isPasswordValidate}
                            onChange={setPassword}
                            id="input-email-password"
                        />
                        {password && isPasswordValidate && <div className="aui-validation-message">{i18n.get("CIS_Home_EmailOTP_Code_Error_Message")}</div>}
                    </Row>
                    <Row>
                        <R.Button
                            text={loginButtonText}
                            classify='info'
                            block
                            attrs={{ 'style': 'border-radius: 8px; font-size:18px; height: 42px;' }}
                            onClick={handleLogin}
                            disabled={loginDisabled || cookieDisable}
                        />
                    </Row>
                </Form>
                <div className='otp-instruction'>
                    <div className='otp-instruction-title'>{i18n.get('CIS_EmailOTP_Instruction_Title_Entry')}</div>
                    <div className='otp-instruction-content'>{i18n.get("CIS_EmailOTP_Instruction_Content_Entry")}</div>
                </div>
            </div>
        </div>
    );
};

export default EmailOTP;